import React from 'react';
import styled from 'styled-components';

const DefaultLabel = styled.div`
  margin-bottom: 2px;
  font-weight: bold;
  font-size: 14px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.8);
`;

interface LabelProps {
  children?: any;
  for?: string;
  active?: boolean;
}

const Label = ({ active, ...props }: LabelProps) => <DefaultLabel {...props} />;
export default Label;
